<template>
  <div>
    <Header />
    <div id="app" class="white-bg container list-grid">
      <div class="col-12 search-box mb-5 clearfix" id="search">
        <div class="row">
            <div class="col-12">
              <label class="title">FILTER:</label>
            </div>
        </div>
        <div class="row">
          <div class="col-12 d-flex mr-2 mb-2">
              <input
                v-model="typeSearch"
                type="text"
                id="typeSearch"
                class="form-control mr-2 mb-2"
                placeholder="Master data type"
                v-on:change="searchData()"
              />
              <button
                id="btnSearch"
                class="btn btn_control mr-2 mb-2"
                type="submit"
                v-on:click="searchData()"
              >Apply</button>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div class="table-box list-grid mb-5" v-if="loading">
          <div class="text-center">
              <div class="spinner-border text-dark" role="status">
                <span class="sr-only">Loading...</span>
              </div>
          </div>
      </div>

      <!-- Table -->
      <div v-else class="table-box list-grid mb-5">
        <div class="row ml-0 mr-0">
          <div class="title col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <h6>TYPE LIST</h6>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 d-flex justify-content-end pl-2">
            <button
              type="button"
              class="btn"
              data-toggle="modal"
              data-target="#masterDataModal"
              v-on:click="openDialogMasterData('add',null,'Master Data Add')"
              style="background-color:#1ab394;color:white;font-size: 14px"
            >Add content type</button>
          </div>
        </div>

        <div class="content-table">
           <table class="table table-hover table-md">
             <thead>
                <tr>
                  <th>ID</th>
                  <th>CODE</th>
                  <th>NAME</th>
                  <th>TYPE</th>
                  <th>CREATE TIME</th>
                  <th>CREATED BY</th>
                  <th>IS ACTIVE</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                <tr class="cell" v-for="item in masterDataList" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>{{ item.code}}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.type }}</td>
                  <td>{{formatDateTime(item.createdTime) }}</td>
                  <td>{{ item.createdBy }}</td>
                  <td v-if="item.active == true" class="icon_status_active">
                    <i class="fa fa-check" aria-hidden="true"></i>
                  </td>
                  <td v-if="item.active == false" class="icon_status_inActive">
                    <i class="fa fa-close" aria-hidden="true"></i>
                  </td>

                  <td class="text-right">
                    <div class="dropdown">
                      <button class="dropbtn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Action
                          <span class="caret"></span>
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            class="dropdown-item"
                            v-on:click="openDialogMasterData('edit',item,'Master Data Edit')"
                            data-toggle="modal" data-target="#masterDataModal"
                            href="javascript:void(0)" v-if="item.using !== true">
                            Edit</a>
                          <a
                            class="dropdown-item"
                            v-on:click="deleteRecord(item.id)"
                            data-toggle="modal"
                            data-target="#deleteMasterDataModal"
                            href="javascript:void(0)"
                            v-if="item.using !== true " >
                            Delete</a>
                          <a
                            class="dropdown-item"
                            v-on:click="openDialogMasterData('view',item,'Master Data View')"
                            data-toggle="modal"
                            data-target="#masterDataModal"
                            href="javascript:void(0)" v-if="item.using === true">
                            View</a>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
           </table>
        </div>

        <!-- padding -->
        <div class="row mt-4 pagination">
          <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pagesize" v-if="total > pageSize">
            <span
                style="color: #3199bb;font-size:12;font-weight:700; "
                v-if="((pageSize*pageNo)>total)"
              >{{pageSize*(pageNo-1)+1}}-{{total}} of {{total}}</span>
              <span
                v-if="((pageSize*pageNo)<=total)"
                style="color: #3199bb;font-size:12;font-weight:700; "
              >{{pageSize*(pageNo-1)+1}}-{{pageSize*pageNo}} of {{total}}</span>
          </div>
          <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 d-flex justify-content-end pageindex" v-if="total > pageSize">
            <b-pagination
                v-model="pageNo"
                pills
                :total-rows="total"
                :per-page="pageSize"
              ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- Add & Edit Master Data Add -->
    <div
      class="modal fade" tabindex="-1"
      id="masterDataModal"
      role="dialog"
      aria-labelledby="masterDataLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id>{{title}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <div class="form-group">
              <label>Type
                <span style="color:red" v-if="action =='add'">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                v-model="dataPopup.typePopup"
                :disabled="action =='edit' || action ==='view'"
              />
              <div class="errors errortemp" style="display:none"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Can not be empty.</div>
            </div>

            <div class="form-group">
              <label>Code
                <span style="color:red" v-if="action =='add'">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                v-model="dataPopup.codePopup"
                :disabled="action ==='edit' || action ==='view'"
              />
              <div class="errors errortemp" style="display:none"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Can not be empty.</div>
            </div>

            <div class="form-group">
              <label>Name
                <span style="color:red" v-if="action !='view'">*</span>
              </label>
              <input type="text" class="form-control" v-model="dataPopup.namePopup" :disabled="action ==='view'"  />
              <div class="errors errortemp" style="display:none"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Can not be empty.</div>
            </div>

            <div class="form-group">
              <label>Is active:</label>
              <input
                    type="checkbox"
                    v-model="dataPopup.activePopup"
                    @click="check($event)" :disabled="action ==='view'"
                  />
                  <label>Active</label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button
              class="btn btn-info"
              v-on:click="addMasterData()"
              v-if="action =='add'"
               id="btn-save"
            >Save</button>
            <button
              class="btn btn-info"
              v-on:click="editMasterData()"
              v-if="action =='edit'"
              id="btn-edit"
            >Save</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Add & Edit Master Data Add end -->
    <!--  delete popup -->
    <div
      class="modal fade"
      id="deleteMasterDataModal"
      role="dialog"
      aria-labelledby="deleteMasterDataModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteMasterDataModalLabel">Delete Master Data</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">Are you sure you want to delete this item?</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >Cancel</button>
            <button
              v-on:click="deleteMasterData"
              type="button"
              class="btn btn-info"
              data-dismiss="modal"
            >Ok</button>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import axios from "axios";
import { BPagination } from "bootstrap-vue";
import helper from "../../common/helper";
import moment from "moment";
export const MASTER_DATA_API_URL = `${CONFIG.API_URL}/master-data`;

import * as CONFIG from "../../config/index";

export default {
  name: "MasterData",
  components: {
    Header,
    Footer,
    "b-pagination": BPagination
  },
  data() {
    return {
      errors:[
      ],
      idRecord: "",
      masterDataList: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      dataPopup: {
        idPopUp: "",
        codePopup: "",
        typePopup: "",
        namePopup: "",
        activePopup: ""
      },
      title: "",
      action: "",
      typeSearch: "",
      loading: false
    };
  },
  methods: {
    searchData: function() {
      this.loading = true;
      this.axios
        .get(
          `${MASTER_DATA_API_URL}/search?type=${this.typeSearch}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
        )
        .then(res => {
          this.masterDataList = res.data.data.items;
          this.total = res.data.data.totals;
          this.loading = false;
        })
        .catch(e => {});
    },
    validateForm : function(){
      this.errors=[];
      if (!this.dataPopup.typePopup) {
       this.errors.push({ type:'Can not be empty'});
     }
     if (!this.dataPopup.namePopup) {
       this.errors.push({ name:'Can not be empty'});
     }
     if (!this.dataPopup.codePopup) {
       this.errors.push({ code:'Can not be empty'});
     }
      if (!this.errors.length) {
        return ;
     }
    },
    addMasterData: function(event) {
      let errors = document.getElementsByClassName('errors');
      let btnSave = document.getElementById('btn-save');
      btnSave.setAttribute('data-dismiss', '');
        if (!this.dataPopup.typePopup) {
            errors[0].style.display = '-webkit-box';
        }
         else if (!this.dataPopup.codePopup) {
            errors[1].style.display = '-webkit-box';
        }
        else if (!this.dataPopup.namePopup) {
            errors[2].style.display = '-webkit-box';
        } else {
      let objAdd = {
        code: this.dataPopup.codePopup,
        name: this.dataPopup.namePopup,
        type: this.dataPopup.typePopup,
        active: this.dataPopup.activePopup
      };
       btnSave.setAttribute('data-dismiss', 'modal');
      this.axios
        .post(`${MASTER_DATA_API_URL}`, objAdd)
        .then(res => {
          helper.successMsg("Add new record successful");
          this.searchData();
        })
        .catch(e => {});
      }
    },
    editMasterData: function(event) {
      let errors = document.getElementsByClassName('errors');
      let btnEdit = document.getElementById('btn-edit');
      btnEdit.setAttribute('data-dismiss', '');
        if (!this.dataPopup.namePopup) {
            errors[2].style.display = '-webkit-box';
            return;
        }
      // this.validateForm();
      let objUpdate = {
        id: this.dataPopup.idPopUp,
        name: this.dataPopup.namePopup,
        active: this.dataPopup.activePopup
      };
       btnEdit.setAttribute('data-dismiss', 'modal');
      this.axios
        .put(`${MASTER_DATA_API_URL}`, objUpdate)
        .then(res => {

          helper.successMsg("Edit record successful");
          this.searchData();
        })
        .catch(e => {});


    },
    openDialogMasterData: function(action, data, title) {
      let errors = document.getElementsByClassName('errors');
      errors[0].style.display = 'none';
      errors[1].style.display = 'none';
      errors[2].style.display = 'none';
      this.errors=[],
      this.clearDataPopup();
      this.title = title;
      this.action = action;
      if (action !== "add") {
        this.dataPopup.idPopUp = data.id;
        this.dataPopup.codePopup = data.code;
        this.dataPopup.namePopup = data.name;
        this.dataPopup.typePopup = data.type;
        this.dataPopup.activePopup = data.active;
      } else {
        this.dataPopup.activePopup = true;
      }
    },
    deleteMasterData: function() {
      let id = this.idRecord;
      this.axios
        .delete(`${MASTER_DATA_API_URL}?id=${id}`)
        .then(res => {
          if (res.data.success == true) {
            helper.successMsg("Delete record successfull");
            this.searchData();
          }
        })
        .catch(e => {});
    },
    deleteRecord: function(id) {
      this.idRecord = id;
    },
    clearDataPopup: function() {
      this.dataPopup.codePopup = "";
      this.dataPopup.namePopup = "";
      this.dataPopup.typePopup = "";
      this.dataPopup.activePopup = "";
    },
    formatDateTime: function(time) {
      if (time != null) {
        return moment(time).format("yyyy-MM-DD");
      }
      return "";
    },
    check: function(e) {
      if (e.target.checked) {
        this.dataPopup.activePopup = true;
      }
    }
  },
  mounted() {
    this.searchData();
  },
  watch: {
    pageNo: {
      immediate: false,
      handler(newVal, oldVal) {
        this.searchData();
      }
    }
  }
};
</script>
<style scoped>
@import '../../assets/css/filter_customs.css';
@import '../../assets/css/table_customs.css';

div .errortemp {
    color: red;
    display: inline-block;
    margin-left: 5px;
}

.icon_status_active{
  text-align: center;
  color: #00cc00;
}

</style>




// WEBPACK FOOTER //
// src/components/pages/MasterData.vue